// Per-document lock password. This is a share code a clinician reads aloud or
// pastes — NOT a cryptographic secret (it is stored reversibly so the signer can
// re-view it). Alphabet drops visually ambiguous characters (0/O, 1/I/L).
export const LOCK_PASSWORD_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const LOCK_PASSWORD_LENGTH = 9;

export function generateLockPassword() {
  const buf = new Uint32Array(LOCK_PASSWORD_LENGTH);
  window.crypto.getRandomValues(buf);
  let s = '';
  for (let i = 0; i < LOCK_PASSWORD_LENGTH; i++) {
    s += LOCK_PASSWORD_ALPHABET[buf[i] % LOCK_PASSWORD_ALPHABET.length];
  }
  return `${s.slice(0, 3)}-${s.slice(3, 6)}-${s.slice(6, 9)}`;
}
